<template>
    <analytics-stat-card
        :loading="loading"
        :error="Boolean(error)"
        :percentage="true"
        :difference="dataComputed.difference"
        :value="dataComputed.number?.value"
        :color="dataComputed.difference < 0 ? 'bad' : 'good'"
        :direction="dataComputed.difference < 0 ? 'down' : 'up'"
    >
        <template v-slot:title>
            <slot name="title">Message Reply Rate</slot>
        </template>
        <template v-slot:subtitle>
            <slot name="subtitle"></slot>
        </template>

        <span>{{ dataComputed.number?.label || '' }}</span>

        <template v-slot:explainHeader>Message Reply Rate</template>
        <template v-slot:explainContent>
            <p>
                <strong>Message Reply Rate</strong><br />
                In the Context of Messages sent, reply percentage of the messages delivered relative to the messages
                delivered during the selected period.
            </p>

            <p>
                <strong>Message Reply Rate %</strong><br />
                Variation of Message Reply Rate relative to the previous period.
            </p>
        </template>
    </analytics-stat-card>
</template>

<script setup>
import { outboundMessagesAnalyticsClient } from '~/services';
import { computed, watch } from 'vue';
import AnalyticsStatCard from '../../partial/AnalyticsStatCard.vue';
import { formatPercentage } from '~/components/filters';
import { computeComparisonRange, calculateDifference, metricsInputValidator } from '~/utils/analytics';
import { useVersionedRequest } from '~/composables/useVersionedRequest';

const props = defineProps({
    fetchParams: {
        type: Object,
        required: true,
        validator: metricsInputValidator,
    },
    orgUnitId: {
        type: Number,
    },
    groupId: {
        type: String,
    },
});

const { loading, response, error, fetchData } = useVersionedRequest();

const dataComputed = computed(() => {
    const values = response.value?.data?.values || [];

    const number = values.length >= 2 ? values[1] : values[0];
    const difference = values.length >= 2 ? calculateDifference(values) : undefined;

    return {
        number: {
            value: number,
            label: formatPercentage(Math.abs(number)),
        },
        difference: difference,
    };
});

watch(
    [() => props.fetchParams],
    () => {
        const params = {
            ...props.fetchParams,
            range: computeComparisonRange(props.fetchParams.range, Boolean(props.groupId), Boolean(props.orgUnitId)),
        };

        fetchData(
            outboundMessagesAnalyticsClient.getMessageReplyRate(
                {
                    teamId: Spark.state.currentTeam.id,
                    orgUnitId: props.orgUnitId,
                    groupId: props.groupId,
                },
                params
            )
        ).catch((e) => {
            console.error(e);
        });
    },
    { immediate: true, deep: true }
);

defineExpose({
    value: computed(() => dataComputed.value.number?.value),
    loading,
});
</script>
